export default __webpack_public_path__ + "static/media/icon-test.873ceb12.svg";